import DateFnsUtils from "@date-io/date-fns"
import { ThemeProvider } from "@material-ui/core"
import { MuiPickersUtilsProvider } from "@material-ui/pickers"
import { Nav } from "components"
import {
  AuthProvider,
  DocumentProvider,
  FileProvider,
  ManagementProvider,
} from "context"
import { es } from "date-fns/locale"
import moment from "moment"
import { BrowserRouter as Router, Switch } from "react-router-dom"
import { theme } from "styles"
import Authentication from "./Authentication/Authentication"
import Closing from "./Closing/Closing"
import Documents from "./Documents/Documents"
import DocumentsReceived from "./DocumentsReceived/DocumentsReceived"
import Payments from "./Payments/Payments"
import Public from "./Public/Public"
import PurchaseOrders from "./PurchaseOrders/PurchaseOrders"
import Received from "./Received/Received"
import Rejected from "./Rejected/Rejected"
import Reports from "./Reports/Reports"
import Resources from "./Resources/Resources"
import Retentions from "./Retentions/Retentions"
import { SnackbarProvider } from "context/notification"
import ReportsReceived from "./ReportsReceived/ReportsReceived"
import Dashboards from "./Dashboards/Dashboards"

moment.locale("es")

const Routes = () => {
  return (
    <Router basename={process.env.REACT_APP_ROOT_PATH}>
      <ThemeProvider theme={theme}>
        <SnackbarProvider>
          <AuthProvider>
            <ManagementProvider>
              <DocumentProvider>
                <FileProvider>
                  <MuiPickersUtilsProvider utils={DateFnsUtils} locale={es}>
                    <Nav>
                      <Switch>
                        <Public />
                      </Switch>
                      <Switch>
                        <Resources />
                      </Switch>
                      <Switch>
                        <Authentication />
                      </Switch>
                      <Switch>
                        <Documents />
                      </Switch>
                      <Switch>
                        <Dashboards />
                      </Switch>
                      <Switch>
                        <DocumentsReceived />
                      </Switch>
                      <Switch>
                        <PurchaseOrders />
                      </Switch>
                      <Switch>
                        <Reports />
                      </Switch>
                      <Switch>
                        <ReportsReceived />
                      </Switch>
                      <Switch>
                        <Rejected />
                      </Switch>
                      <Switch>
                        <Closing />
                      </Switch>
                      <Switch>
                        <Received />
                      </Switch>
                      <Switch>
                        <Retentions />
                      </Switch>
                      <Switch>
                        <Payments />
                      </Switch>
                    </Nav>
                  </MuiPickersUtilsProvider>
                </FileProvider>
              </DocumentProvider>
            </ManagementProvider>
          </AuthProvider>
        </SnackbarProvider>
      </ThemeProvider>
    </Router>
  )
}

export default Routes
